import React, { Suspense } from "react";
import { useTranslation } from 'react-i18next';
import { MedicationItem, Drug, Drip } from "./types";
import { MedicationGivenInfo } from "./CprState/types";
import DrugComponent from "../Resus/Drug";
import DripComponent from "../Resus/Drip";
import { useResusContext } from "../Resus/ResusContext";
import { evaluateMedicationPredicate } from "../Resus/predicateUtils";

interface MedicationTableRowProps {
	item: MedicationItem;
	givenInfo?: MedicationGivenInfo;
	onGiveMedication: (item: MedicationItem) => void;
	customComment?: string;
}

const MedicationTableRow: React.FC<MedicationTableRowProps> = ({
	item,
	givenInfo,
	onGiveMedication,
	customComment,
}) => {
	const { weight, age } = useResusContext();
	const { t } = useTranslation(['resus']);
	const dosageText = (givenInfo?.details && givenInfo.details.medicalSectionLog) ?? "";
	const predicateResult = evaluateMedicationPredicate(item, age || 0, weight || 0, t);
	const isAdministerButtonDisabled = (predicateResult && !predicateResult.isValid) || false;
	const administerButtonStyle = {
		padding: "8px 16px",
		minWidth: "max-content",
	}
	let onGiveMedicationButtonStyle = { ...administerButtonStyle, cursor: "pointer" };
	let onGiveMedicationDisabledButtonStyle = { ...administerButtonStyle, opacity: "0.5" };

	return (
		<div className="Card card">
			<div className="Card-body">
				<div className="content">
					<Suspense fallback={<div>Loading...</div>}>
						{item.isDrip ? (
							<DripComponent drip={item as Drip} customComment={customComment} predicateResult={predicateResult} />
						) : (
							<DrugComponent drug={item as Drug} customComment={customComment} predicateResult={predicateResult} />
						)}
					</Suspense>
					{dosageText && (
						<span style={{textAlign: "left", fontSize: '0.9em', color: 'rgb(102, 102, 102)'}}>
							{t('medications.givenWithDosage', { dosage: dosageText })}
						</span>
					)}
				</div>
				<div className="actions">
					<button
						onClick={() => onGiveMedication(item)}
						className="btn btn-reset"
						data-testid={`medications-${item.id}-give`}
						style={isAdministerButtonDisabled ? onGiveMedicationDisabledButtonStyle : onGiveMedicationButtonStyle}
						disabled={isAdministerButtonDisabled}>
						{t('medications.administrationButton')}
					</button>
					{givenInfo && (
				<div
					style={{
						fontSize: "0.9em",
						color: "#666",
						overflow: "hidden",
						textOverflow: "ellipsis",
						padding: "0 4px",
						boxSizing: "border-box",
						wordWrap: "break-word",
						direction: "rtl",
						marginTop: "8px"
					}}
				>
					{t('medications.lastAdministeredAt', { time: givenInfo.time })}
				</div>
			)}

				</div>
			</div>
		</div>
	);
};

export default MedicationTableRow;